export const SeoPropertyTypes = [
'houses',
'townhouses',
'condos'
]
